import { useState } from 'react';
import { Link } from 'react-router-dom';
import { site } from '@/data/site';
import type { GameData } from '@/data/games';

interface GameCardProps {
  game: GameData;
}

export default function GameCard({ game }: GameCardProps) {
  const [imgError, setImgError] = useState(false);
  const downloadUrl = game.downloadUrl || site.affiliateUrl;

  return (
    <div className="bg-white rounded-2xl border border-background-200 overflow-hidden relative flex items-center gap-3 p-3 hover:border-background-300 transition-colors cursor-pointer">
      {game.isPopular && (
        <span className="absolute top-2.5 right-2.5 px-1.5 py-0.5 bg-primary-500 text-white rounded text-[9px] font-semibold leading-none">
          POPULAR
        </span>
      )}
      {!game.isPopular && game.isNew && (
        <span className="absolute top-2.5 right-2.5 px-1.5 py-0.5 bg-accent-500 text-white rounded text-[9px] font-semibold leading-none">
          NEW
        </span>
      )}

      {/* Icon */}
      {!imgError ? (
        <img
          src={game.imageUrl}
          alt={game.name}
          width={56}
          height={56}
          loading="lazy"
          className="w-[56px] h-[56px] rounded-2xl object-cover flex-shrink-0 bg-background-100"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className={`w-[56px] h-[56px] rounded-2xl ${game.iconBg} flex items-center justify-center flex-shrink-0`}>
          <i className="ri-gamepad-line text-lg text-white"></i>
        </div>
      )}

      {/* Middle: Name + Category + Stats */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <h3 className="font-heading font-semibold text-foreground-900 text-[14px] leading-tight truncate">
            {game.name}
          </h3>
          <span className="flex-shrink-0 text-[10px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full">
            {game.category}
          </span>
        </div>
        <div className="flex items-center gap-3 text-[11px]">
          <span className="text-foreground-500">
            Bonus: <strong className="text-accent-600 font-semibold">{game.welcomeBonus}</strong>
          </span>
          <span className="text-foreground-400">·</span>
          <span className="text-foreground-500">
            Min. Withdraw: <span className="text-foreground-700 font-medium">{game.minimumWithdrawal}</span>
          </span>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex flex-col items-center flex-shrink-0 gap-1">
        <a
          href={downloadUrl}
          target="_blank"
          rel="sponsored nofollow noopener noreferrer"
          className="px-4 py-2 bg-primary-500 text-white rounded-lg text-xs font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          Download APK
        </a>
        <Link
          to={`/games/${game.slug}`}
          className="text-[10px] text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          Details
        </Link>
      </div>
    </div>
  );
}